import { createContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import toast from "react-hot-toast";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState({});
  const [userEventCode, setUserEventCode] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setLoading(true);
      if (user) {
        // Fetch user's eventCode from Firestore
        try {
          console.log("Fetching user data for UID:", user.uid);
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            console.log("User data fetched:", userData);
            
            // Get current active event (new format) or fallback to old eventCode
            const currentEvent = userData.currentEvent || userData.eventCode;
            const userEvents = userData.events || [userData.eventCode].filter(Boolean);
            
            setUserEventCode(currentEvent);
            setCurrentUser({ 
              ...user, 
              eventCode: currentEvent, 
              currentEvent: currentEvent,
              events: userEvents 
            });
            
            console.log("Current event set:", currentEvent);
            console.log("All user events:", userEvents);
            
            // Small delay to ensure state is properly set
            setTimeout(() => {
              console.log("Final state check - userEventCode:", currentEvent);
            }, 100);
          } else {
            console.log("User document does not exist");
            setCurrentUser(user);
            setUserEventCode(null);
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          toast.error("Error loading user data. Please try logging in again.");
          setCurrentUser(user);
          setUserEventCode(null);
        }
      } else {
        setCurrentUser({});
        setUserEventCode(null);
      }
      setLoading(false);
      console.log("Auth state updated - User:", user, "EventCode:", userEventCode);
    });

    return () => {
      unsub();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, userEventCode, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
